import React from "react";

const SummaryCard = ({ 
  icon: Icon, 
  title, 
  value, 
  color = "#5B21B6",
  className = "" 
}) => (
  <div className={`w-full p-4 rounded border border-slate-300 relative overflow-hidden group bg-white ${className}`}>
    <div
      className="absolute inset-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300"
      style={{ backgroundColor: color }}
    />
    <Icon className="absolute z-10 -top-12 -right-12 text-9xl text-slate-100 group-hover:text-white group-hover:rotate-12 transition-transform duration-300" />
    <Icon className="mb-2 text-2xl text-[#672c71] group-hover:text-white relative z-10 duration-300" />
    <h3 className="font-medium text-lg text-slate-950 group-hover:text-white relative z-10 duration-300">
      {value}
    </h3>
    <p className="text-slate-400 group-hover:text-white relative z-10 duration-300">{title}</p>
  </div>
);

export default SummaryCard;